import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTillToLength = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 90,
	viewBox: "0 0 200 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2938_31080",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 200,
		height: 90,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 90,
			fill: "#C4C4C4"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_2938_31080)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M59.5118 44.9999C59.5118 35.7084 63.1074 28.1269 67.6836 27.557L67.6836 27.5L26.7431 27.5C21.9219 27.5 17.9994 35.3095 17.9994 45C17.9994 54.6905 21.9219 62.5 26.7431 62.5L67.6836 62.5L67.6836 62.443C63.1074 61.8728 59.5118 54.2914 59.5118 44.9999Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.5125 45C59.5125 54.2915 63.1081 61.873 67.6842 62.4429C67.8477 62.4999 68.0928 62.4999 68.2562 62.4999C73.0775 62.5 77 54.6905 77 45C77 35.3095 73.0775 27.5 68.2562 27.5C68.0928 27.5 67.8477 27.5 67.6842 27.557C63.1081 28.127 59.5125 35.7085 59.5125 45Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M97.8667 40.6125L108.544 40.6125L106.179 38.0508C106.017 37.875 105.926 37.6366 105.926 37.3879C105.926 37.1393 106.017 36.9009 106.179 36.725L106.792 36.061C106.873 35.9736 106.968 35.9042 107.074 35.8569C107.179 35.8096 107.292 35.7852 107.405 35.7852C107.519 35.7852 107.632 35.8096 107.737 35.8569C107.843 35.9042 107.938 35.9736 108.018 36.061L112.903 41.3559C113.065 41.5317 113.156 41.7702 113.156 42.0188C113.156 42.2674 113.065 42.5059 112.903 42.6817L108.016 47.9762C107.935 48.0636 107.84 48.133 107.734 48.1803C107.629 48.2276 107.516 48.252 107.403 48.252C107.289 48.252 107.176 48.2276 107.071 48.1803C106.966 48.133 106.87 48.0636 106.79 47.9762L106.177 47.3122C106.014 47.1363 105.923 46.8979 105.923 46.6493C105.923 46.4006 106.014 46.1622 106.177 45.9864L108.541 43.425L97.8667 43.425C97.6372 43.425 97.4171 43.3263 97.2548 43.1505C97.0925 42.9746 97.0014 42.7362 97.0014 42.4875L97.0014 41.55C97.0014 41.3014 97.0925 41.0629 97.2548 40.8871C97.4171 40.7113 97.6372 40.6125 97.8667 40.6125Z",
				fill: "#F6DCC4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M160.5 32.9877C151.208 32.9877 143.627 29.3921 143.057 24.8159H143V65.7564C143 70.5776 150.809 74.5001 160.5 74.5001C170.191 74.5001 178 70.5776 178 65.7564V24.8159H177.943C177.373 29.3921 169.791 32.9877 160.5 32.9877Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M160.5 32.9875C169.792 32.9875 177.373 29.3919 177.943 24.8158C178 24.6523 178 24.4072 178 24.2438C178 19.4225 170.191 15.5 160.5 15.5C150.809 15.5 143 19.4225 143 24.2438C143 24.4072 143 24.6523 143.057 24.8158C143.627 29.3919 151.208 32.9875 160.5 32.9875Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			})
		]
	})]
});
export default SvgTillToLength;
